// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MentionList_dropdown__3FPrP"};